const Footer = () => {
    return (
        <footer className="sticky-footer bg-white" style={{height: '2px'}}>
            <div className="container my-auto" >
                <div className="copyright text-center my-auto">
                    <span>Copyright &copy; Your Website 2020</span>
                </div>
            </div>
        </footer>
    );
}

export default Footer;